import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { ConfigProvider, ThemeConfig } from "antd";
import { ToastContainer } from "react-toastify";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import "./index.css";
import { queryClient } from "./common/utils";
import route from "./route";

const config: ThemeConfig = {
  components: {
    Card: {},
    Collapse: {
      headerBg: "#ffffff",
      contentBg: "transparent",
    },
    Table: {
      headerBg: "rgb(245 245 245 / var(--tw-bg-opacity, 1))",
      borderColor: "rgb(245 245 245 / var(--tw-bg-opacity, 1))",
    },
    Select: {
      activeOutlineColor: "none",
      colorIcon: "#0f0f0f",
      colorBgBase: "transparent",
      colorBgSolidHover: "transparent",
      fontFamily: "Kanit",
      fontSize: 14,
    },
    Checkbox: {
      colorBgSolidActive: "#D8F2D4",
      colorBgBase: "#D8F2D4",
      colorPrimaryBg: "#D8F2D4",
    },
    Tabs: {
      inkBarColor: "transparent",
      cardPadding: "0px",
      horizontalItemGutter: 8,
      margin: 0,
    },
    Input: {
      colorBgContainerDisabled: "#F5F5F5",
      colorBgBase: "#F3F9FC",
      colorBgContainer: "#F3F9FC",
    },
    Pagination: {
      itemActiveBg: "#0e72ff",
    },
    DatePicker: {
      colorTextDisabled: "#0f0f0f",
      colorIcon: "#0f0f0f",
      colorBgContainerDisabled: "#F3F9FC",
    },
    Form: {
      itemMarginBottom: 0,
    },
  },
};

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ConfigProvider theme={config}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={route} />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
      <ToastContainer />
    </ConfigProvider>
  </StrictMode>
);
